import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// utils
import apiSlice from "src/utils/api-slice";
// slices
import apiKeysReducer from "./slices/api-keys";
import planReducer from "./slices/plan";
import taskReducer from "./slices/task";
import carrierReducer from "./slices/carrier";
import transactionReducer from "./slices/transaction";
import scanFormReducer from "./slices/scan-form";
import otherReducer from "./slices/other";
import pickupReducer from "./slices/pickup";
import automationReducer from "./slices/automation";
import shipmentReducer from "./slices/shipment";
import errorReducer from "./slices/error";
import billingReducer from "./slices/billing";
import webhooksReducer from "./slices/webhooks";

// ----------------------------------------------------------------------

const rootPersistConfig = {
    key: "root",
    storage,
    keyPrefix: "redux-",
    whitelist: null, // 持久化所有 reducer
    blacklist: ['shipment','transaction','pickup','scanForm','task']
};

const appReducer = combineReducers({
    task: taskReducer,
    shipment: shipmentReducer,
    //
    transaction: transactionReducer,
    plan: planReducer,
    apiKeys: apiKeysReducer,
    carrier: carrierReducer,
    scanForm: scanFormReducer,
    pickup: pickupReducer,
    automation: automationReducer,
    other: otherReducer,
    //
    billing: billingReducer,
    webhooks: webhooksReducer,
    //
    error: errorReducer,
    //
    [ apiSlice.reducerPath ]: apiSlice.reducer
});

const rootReducer = (state, action) => {
    if (action.type === "RESET") {
        storage.removeItem("persist:root"); // for all keys defined in your persistConfig(s)

        return appReducer(undefined, action);
    }

    return appReducer(state, action);
};

// Persist Reducer
export default persistReducer(rootPersistConfig, rootReducer);
